const IsObjectFull = (obj) => {
    return Object.values(obj).some((key) => key === "")
}

export default IsObjectFull